import { useSite } from "../context/SiteContentContext";

export const About = () => {
    const siteConfig = useSite();
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 md:py-32 px-6 md:px-12 bg-[#121212] overflow-hidden"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    {/* Image */}
                    <div className="lg:col-span-5 relative">
                        <div className="relative aspect-[3/4] overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1619233543112-fe382ff3693d?w=900"
                                alt="Barbeiro em acção"
                                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 border border-[#d4af37]/20 pointer-events-none" />
                            {/* Logo seal in corner */}
                            <img
                                src="/logo-barbearia18-light.png"
                                alt=""
                                aria-hidden
                                className="absolute top-5 left-5 h-20 md:h-24 w-auto opacity-80 mix-blend-screen pointer-events-none"
                                loading="lazy"
                            />
                        </div>

                        {/* Accent box */}
                        <div className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 bg-[#d4af37] text-[#0a0a0a] p-6 md:p-8 max-w-[260px]">
                            <div className="font-display text-5xl md:text-6xl font-black leading-none">
                                {siteConfig.about.years}
                            </div>
                            <div className="text-xs tracking-widest uppercase font-semibold mt-2">
                                {siteConfig.about.yearsLabel}
                            </div>
                        </div>
                    </div>

                    {/* Text */}
                    <div className="lg:col-span-7 lg:pl-8">
                        <div className="ornamental-divider mb-6">
                            <span>Sobre nós</span>
                        </div>

                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-[#f5f5f0] mb-8">
                            {siteConfig.about.title}
                        </h2>

                        <p className="font-body text-base md:text-lg text-[#a3a3a3] leading-relaxed mb-10 max-w-xl">
                            {siteConfig.about.body}
                        </p>

                        <div className="grid grid-cols-2 gap-8 max-w-md border-t border-[#262626] pt-8">
                            <div>
                                <div className="font-display text-3xl md:text-4xl font-bold text-[#f5f5f0]">
                                    {siteConfig.about.clients}
                                </div>
                                <div className="text-xs tracking-widest uppercase text-[#737373] mt-1">
                                    {siteConfig.about.clientsLabel}
                                </div>
                            </div>
                            <div>
                                <div className="font-display text-3xl md:text-4xl font-bold text-[#d4af37]">
                                    Sintra
                                </div>
                                <div className="text-xs tracking-widest uppercase text-[#737373] mt-1">
                                    barbeiro local
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
